const KEY = 'iwb_v4_outputs'

function read(storage) {
  try { const value = JSON.parse(storage?.getItem?.(KEY) || '[]'); return Array.isArray(value) ? value : [] } catch { return [] }
}

export function createOutputRepository({ storage = globalThis.localStorage } = {}) {
  return {
    list() { return read(storage) },
    add(items) {
      const next = [...items, ...read(storage)].slice(0, 1000)
      storage?.setItem?.(KEY, JSON.stringify(next))
      return next
    },
    clear() { storage?.removeItem?.(KEY) },
  }
}
